import { render, staticRenderFns } from "./commissionDetail.vue?vue&type=template&id=b9693a9a&"
import script from "./commissionDetail.vue?vue&type=script&lang=js&"
export * from "./commissionDetail.vue?vue&type=script&lang=js&"
import style0 from "./commissionDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports